import { useMemo } from 'react';
import { diffLines } from 'diff';

// Compact line diff (old = current document, new = incoming Writer version).
// Styles live in WriterPull.css (WriterPull__diff*).
function Diff({ oldText, newText }) {
    const rows = useMemo(() => {
        const parts = diffLines(oldText ?? '', newText ?? '');
        const out = [];
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            const lines = part.value.replace(/\n$/, '').split('\n');
            const kind = part.added ? 'add' : part.removed ? 'del' : 'ctx';
            if (kind === 'ctx') {
                const head = i === 0 ? [] : lines.slice(0, 3);
                const tail = i === parts.length - 1 ? [] : lines.slice(-3);
                const hidden = lines.length - head.length - tail.length;
                if (hidden > 0) {
                    head.forEach((l) => out.push({ kind, text: l }));
                    out.push({ kind: 'gap', text: `${hidden} unchanged lines` });
                    tail.forEach((l) => out.push({ kind, text: l }));
                } else {
                    lines.forEach((l) => out.push({ kind, text: l }));
                }
            } else {
                lines.forEach((l) => out.push({ kind, text: l }));
            }
            if (out.length > 400) {
                out.length = 400;
                out.push({ kind: 'gap', text: 'diff truncated…' });
                break;
            }
        }
        return out;
    }, [oldText, newText]);

    return (
        <div className="WriterPull__diff">
            {rows.map((row, i) => (
                <div key={i} className={`WriterPull__diff-line WriterPull__diff-line--${row.kind}`}>
                    <span className="WriterPull__diff-sign">
                        {row.kind === 'add' ? '+' : row.kind === 'del' ? '−' : row.kind === 'gap' ? '⋯' : ' '}
                    </span>
                    <span>{row.text || ' '}</span>
                </div>
            ))}
        </div>
    );
}

export default Diff;
